<script setup lang="ts">
// What a change would interrupt, asked before it is saved (store.planned,
// the node's plan.go): settings that change live save at once; this shows
// only when something running has to restart, reconnect or lose its caster.
import { computed } from 'vue'
import { useNode } from '../store'
import type { Change } from '../api'
import ConfirmDialog from './ConfirmDialog.vue'

const node = useNode()
const what: Record<Change['action'], string> = {
    restart: 'restarts',
    reconnect: 'reconnects',
    caster: 'caster cut off',
    return: 'return feed starts over',
    comms: 'comms start over',
}
const rows = computed(() =>
    (node.pendingPlan?.changes ?? []).map((c) => ({ ...c, label: c.name || c.id, verb: what[c.action] })),
)
function answer(ok: boolean) {
    node.pendingPlan?.resolve(ok)
    node.pendingPlan = null
}
</script>

<template>
    <!-- above the drawers (z-21) whose Save asked: their form stays under it -->
    <div v-if="node.pendingPlan" class="relative z-30">
        <ConfirmDialog
            title="This change interrupts what is running"
            body="Saving it does this; anything else in the change goes live without a break."
            confirm-label="Save and restart"
            danger
            @confirm="answer(true)"
            @cancel="answer(false)"
        >
            <ul class="mt-0 mb-3.5 list-none space-y-1.5 p-0 text-sm" data-test="changes">
                <li v-for="r in rows" :key="r.kind + r.id + r.action">
                    <b>{{ r.label }}</b> <span class="text-xs text-fg-2">{{ r.kind }}</span> ·
                    <span class="text-warn">{{ r.verb }}</span>
                    <div class="text-xs text-fg-2">{{ r.why }}</div>
                </li>
            </ul>
        </ConfirmDialog>
    </div>
</template>
